import React from 'react';
import { Tooltip, Typography } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import './FieldSet.css';

const MIN_COUNT_FOR_TOOLTIP = 100;
const TOOLTIP_DELAY_IN_MS_TILE = 500;

function FieldSet({ fieldData, type, isBlank, isLink }) {
  const transformData = (value) => {
    if (value === true) {
      return 'Yes';
    }

    if (value === false) {
      return 'No';
    }

    if (value === null || value === undefined) {
      return '-';
    }

    return `${value}`;
  };

  return (
    <div
      className={
        type === 'compact' ? 'FieldSet-fieldset--compact' : 'FieldSet-fieldset'
      }>
      <Typography kind='body3' className='FieldSet-fieldsetLabel'>
        {fieldData.label}
      </Typography>
      <Tooltip
        openDelay={TOOLTIP_DELAY_IN_MS_TILE}
        text={
          fieldData?.value?.length > MIN_COUNT_FOR_TOOLTIP
            ? fieldData.value
            : null
        }
        maxWidth='20rem'
        placement='bottom'
        offset={8}
        trigger={
          <Typography
            kind='body2'
            className={
              isBlank
                ? 'FieldSet-fieldsetValue--blank'
                : 'FieldSet-fieldsetValue--filled'
            }>
            {isLink ? fieldData.value : transformData(fieldData.value)}
          </Typography>
        }
      />
    </div>
  );
}

FieldSet.propTypes = {
  // TODO: @Jacob, CR-17904, Set to any for RTL/MSW testing, Warning: Invalid argument supplied to oneOf, expected an array.
  // eslint-disable-next-line react/forbid-prop-types
  fieldData: PropTypes.any,
  type: PropTypes.string,
  isBlank: PropTypes.bool,
  isLink: PropTypes.bool,
};

FieldSet.defaultProps = {
  type: '',
  fieldData: {
    label: ' ',
    value: ' ',
  },
  isBlank: false,
  isLink: false,
};

export default FieldSet;
